import Classic from './classic'

const Layouts = {
  Classic
}

export default Layouts
